import { ColumnDetails, ColumnType } from '../../../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../../../utils/translator.helper';
import { getContentControlLightRuleItemStatusGridValues } from '../../../../../../../utils/uiSettings/contentControl/content-control.values';

export enum Column {
  NAME = 1,
  STATUS = 2,
}

export enum ColumnKeys {
  NAME = 'name',
  STATUS = 'status',
}

export const GRID_COLUMNS = [Column.NAME, Column.STATUS];

export const FILTERS = [{ [ColumnKeys.NAME]: { contains: '' } }, { [ColumnKeys.STATUS]: { in: [] } }];
export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.NAME, ColumnKeys.STATUS];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.NAME,
      key: ColumnKeys.NAME,
      columnName: translateFn('Rule name'),
      type: ColumnType.STRING,
      removable: false,
      filteringDisabled: true,
      sortable: true,
    },
    {
      column: Column.STATUS,
      key: ColumnKeys.STATUS,
      columnName: translateFn('Status'),
      type: ColumnType.ENUM,
      values: getContentControlLightRuleItemStatusGridValues(),
      removable: false,
      filteringDisabled: true,
      sortable: true,
      editingDisabled: true,
    },
  ];
}
